module.exports = __webpack_public_path__ + "img/gal_9.030362e5.png";